/**
 * Awaits each delay in turn and runs `attempt`, stopping at the first attempt that
 * reports completion. Returns whether an attempt completed before the budget ran out.
 */
export async function runBackoffPoll(
  delaysMs: readonly number[],
  attempt: () => Promise<boolean>,
): Promise<boolean> {
  for (const delayMs of delaysMs) {
    await new Promise((resolve) => setTimeout(resolve, delayMs));
    if (await attempt()) {
      return true;
    }
  }

  return false;
}
